import { render, staticRenderFns } from "./bongoProject.vue?vue&type=template&id=683ff4ac&"
import script from "./bongoProject.vue?vue&type=script&lang=js&"
export * from "./bongoProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports